class FacetFiltersForm extends HTMLElement {
	constructor() {
		super();
		this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

		this.debouncedOnSubmit = debounce((event) => {
			this.onSubmitHandler(event);
		}, 500);

		const facetForm = this.querySelectorAll('form').forEach((el) => {
			el.addEventListener('input', this.debouncedOnSubmit.bind(this));
		});

		const facetWrapper = this.querySelector('#FacetFiltersFormFilters');
		if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

		const facetSortWrapper = this.querySelector('#FacetFiltersFormSort');
		if (facetSortWrapper)
			facetSortWrapper.addEventListener('keyup', onKeyUpEscape);
	}

	static setListeners() {
		const onHistoryChange = (event) => {
			const searchParams = event.state
				? event.state.searchParams
				: FacetFiltersForm.searchParamsInitial;
			if (searchParams === FacetFiltersForm.searchParamsPrev) return;
			FacetFiltersForm.renderPage(searchParams, null, false);
		};
		window.addEventListener('popstate', onHistoryChange);
	}

	static toggleActiveFacets(disable = true) {
		document.querySelectorAll('.js-facet-remove').forEach((element) => {
			element.classList.toggle('disabled', disable);
		});
	}

	static renderPage(searchParams, event, updateURLHash = true) {
		searchParams += '&filter.v.availability=1';

		FacetFiltersForm.searchParamsPrev = searchParams;
		const sections = FacetFiltersForm.getSections();
		const countContainer = document.getElementById('ProductCount');
		const countContainerDesktop = document.getElementById(
			'ProductCountDesktop',
		);
		document
			.getElementById('ProductGridContainer')
			.querySelector('.collection')
			.classList.add('loading');
		if (countContainer) {
			countContainer.classList.add('loading');
		}
		if (countContainerDesktop) {
			countContainerDesktop.classList.add('loading');
		}

		sections.forEach((section) => {
			const url = `${window.location.pathname}?section_id=${section.section}&${decodeURIComponent(searchParams)}`;

			const filterDataUrl = (element) => element.url === url;

			FacetFiltersForm.filterData.some(filterDataUrl)
				? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
				: FacetFiltersForm.renderSectionFromFetch(url, event);
		});

		if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
	}

	static renderSectionFromFetch(url, event) {
		fetch(url)
			.then((response) => response.text())
			.then((responseText) => {
				const html = responseText;
				FacetFiltersForm.filterData = [
					...FacetFiltersForm.filterData,
					{html, url},
				];
				FacetFiltersForm.renderFilters(html, event);
				FacetFiltersForm.renderProductGridContainer(html);
				FacetFiltersForm.renderProductCount(html);
				FacetFiltersForm.dispatchUpdated();
			});
	}

	static renderSectionFromCache(filterDataUrl, event) {
		const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
		FacetFiltersForm.renderFilters(html, event);
		FacetFiltersForm.renderProductGridContainer(html);
		FacetFiltersForm.renderProductCount(html);
		FacetFiltersForm.dispatchUpdated();
	}

	static dispatchUpdated() {
		window.dispatchEvent(new Event('facets:updated', {bubbles: true}));
	}

	static renderProductGridContainer(html) {
		document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
			.parseFromString(html, 'text/html')
			.getElementById('ProductGridContainer').innerHTML;
	}

	static renderProductCount(html) {
		const count = new DOMParser()
			.parseFromString(html, 'text/html')
			.getElementById('ProductCount').innerHTML;
		const container = document.getElementById('ProductCount');
		const containerDesktop = document.getElementById('ProductCountDesktop');
		container.innerHTML = count;
		container.classList.remove('loading');
		if (containerDesktop) {
			containerDesktop.innerHTML = count;
			containerDesktop.classList.remove('loading');
		}
	}

	static renderFilters(html, event) {
		const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

		const facetDetailsElements = parsedHTML.querySelectorAll(
			'#FacetFiltersFormFilters .js-filter, #FacetFiltersFormSort .js-filter, #FacetFiltersPillsForm .js-filter',
		);
		const matchesIndex = (element) => {
			const jsFilter = event ? event.target.closest('.js-filter') : undefined;
			return jsFilter
				? element.dataset.index === jsFilter.dataset.index
				: false;
		};
		const facetsToRender = Array.from(facetDetailsElements).filter(
			(element) => !matchesIndex(element),
		);
		const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

		facetsToRender.forEach((element) => {
			document.querySelector(
				`.js-filter[data-index="${element.dataset.index}"]`,
			).innerHTML = element.innerHTML;
		});

		FacetFiltersForm.renderActiveFacets(parsedHTML);
		FacetFiltersForm.renderAdditionalElements(parsedHTML);

		if (countsToRender)
			FacetFiltersForm.renderCounts(
				countsToRender,
				event.target.closest('.js-filter'),
			);
	}

	static renderActiveFacets(html) {
		const activeFacetElementSelectors = [
			'.active-facets-mobile',
			'.active-facets-desktop',
		];

		activeFacetElementSelectors.forEach((selector) => {
			const activeFacetsElement = html.querySelector(selector);
			if (!activeFacetsElement) return;
			document.querySelector(selector).innerHTML =
				activeFacetsElement.innerHTML;
		});

		FacetFiltersForm.toggleActiveFacets(false);
	}

	static renderAdditionalElements(html) {
		const mobileElementSelectors = [
			'.mobile-facets__open',
			'.mobile-facets__count',
			'.sorting',
			'[data-active-filter]',
		];

		mobileElementSelectors.forEach((selector) => {
			if (!html.querySelector(selector)) return;
			document.querySelector(selector).innerHTML =
				html.querySelector(selector).innerHTML;
		});

		document
			.getElementById('FacetFiltersFormMobile')
			.closest('menu-drawer')
			.bindEvents();
	}

	static renderCounts(source, target) {
		const targetElement = target.querySelector('.facets__selected');
		const sourceElement = source.querySelector('.facets__selected');

		const targetElementAccessibility = target.querySelector('.facets__summary');
		const sourceElementAccessibility = source.querySelector('.facets__summary');

		if (sourceElement && targetElement) {
			target.querySelector('.facets__selected').outerHTML =
				source.querySelector('.facets__selected').outerHTML;
		}

		if (targetElementAccessibility && sourceElementAccessibility) {
			target.querySelector('.facets__summary').outerHTML =
				source.querySelector('.facets__summary').outerHTML;
		}
	}

	static updateURLHash(searchParams) {
		let decodeURI = decodeURIComponent(searchParams);
		history.pushState(
			{decodeURI},
			'',
			`${window.location.pathname}${decodeURI && '?'.concat(decodeURI)}`,
		);
	}

	static getSections() {
		return [
			{
				section: document.getElementById('product-grid').dataset.id,
			},
		];
	}

	createSearchParams(form) {
		const formData = new FormData(form);
		return new URLSearchParams(formData).toString();
	}

	onSubmitForm(searchParams, event) {
		FacetFiltersForm.renderPage(searchParams, event);
	}

	onSubmitHandler(event) {
		event.preventDefault();
		const sortFilterForms = document.querySelectorAll(
			'facet-filters-form form',
		);
		if (event.srcElement.className == 'mobile-facets__checkbox') {
			const searchParams = this.createSearchParams(
				event.target.closest('form'),
			);
			this.onSubmitForm(searchParams, event);
		} else {
			const forms = [];
			const isMobile =
				event.target.closest('form').id === 'FacetFiltersFormMobile';

			sortFilterForms.forEach((form) => {
				if (!isMobile) {
					if (
						form.id === 'FacetSortForm' ||
						form.id === 'FacetFiltersFormSort' ||
						form.id === 'FacetFiltersFormFilters' ||
						form.id === 'FacetFiltersForm' ||
						form.id === 'FacetSortDrawerForm'
					) {
						forms.push(this.createSearchParams(form));
					}
				} else if (form.id === 'FacetFiltersFormMobile') {
					forms.push(this.createSearchParams(form));
				}
			});
			this.onSubmitForm(forms.join('&'), event);
		}
	}

	onActiveFilterClick(event) {
		event.preventDefault();
		FacetFiltersForm.toggleActiveFacets();
		const url =
			event.currentTarget.href.indexOf('?') == -1
				? ''
				: event.currentTarget.href.slice(
						event.currentTarget.href.indexOf('?') + 1,
					);

		FacetFiltersForm.renderPage(url);
	}
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
	constructor() {
		super();
		this.querySelectorAll('input[type="range"]').forEach((element) =>
			element.addEventListener('input', this.onRangeChange.bind(this)),
		);
		this.setMinAndMaxValues();
	}

	onRangeChange(event) {
		const minInput = this.querySelector('[data-price-range-min]');
		const maxInput = this.querySelector('[data-price-range-max]');

		// Limiter la plage de prix à 50€
		const min = parseFloat(minInput.value);
		const max = parseFloat(maxInput.value);
		const diffMinMax = 1;
		if (max - min < diffMinMax) {
			if (event.currentTarget === minInput) {
				maxInput.value = min + diffMinMax;
			} else {
				minInput.value = max - diffMinMax;
			}
		}

		const realInputMin = this.querySelector('input[name="filter.v.price.gte"]');
		const realInputMax = this.querySelector('input[name="filter.v.price.lte"]');

		realInputMin.value = minInput.value;
		realInputMax.value = maxInput.value;

		this.adjustToValidValues(event.currentTarget);
		this.setMinAndMaxValues();
		this.updateTrackColors(); // Appel pour mettre à jour les couleurs
	}

	setMinAndMaxValues() {
		const minActiveValueElement = this.querySelector('[data-min-active-value]');
		const maxActiveValueElement = this.querySelector('[data-max-active-value]');
		const currency = this.getAttribute('data-currency');
		const inputs = this.querySelectorAll('input[type="range"]');
		const minInput = inputs[0];
		const maxInput = inputs[1];

		if (minInput.value)
			minActiveValueElement.textContent = `${minInput.value}${currency}`;
		if (maxInput.value)
			maxActiveValueElement.textContent = `${maxInput.value}${currency}`;

		this.updateTrackColors(); // Appel pour mettre à jour les couleurs
	}

	adjustToValidValues(input) {
		const value = parseFloat(input.value);
		const min = parseFloat(input.getAttribute('min'));
		const max = parseFloat(input.getAttribute('max'));

		if (value < min) input.value = min;
		if (value > max) input.value = max;
	}

	updateTrackColors() {
		const minInput = this.querySelector('[data-price-range-min]');
		const maxInput = this.querySelector('[data-price-range-max]');
		const min = parseFloat(minInput.value);
		const max = parseFloat(maxInput.value);
		const rangeMin = parseFloat(minInput.getAttribute('min'));
		const rangeMax = parseFloat(maxInput.getAttribute('max'));

		const minPercentage = ((min - rangeMin) / (rangeMax - rangeMin)) * 100;
		const maxPercentage = ((max - rangeMin) / (rangeMax - rangeMin)) * 100;

		minInput.style.background = `linear-gradient(to right, 
      #d9d9d9 ${minPercentage}%, 
      #000000 ${minPercentage}%, 
      #000000 ${maxPercentage}%, 
      #d9d9d9 ${maxPercentage}%)`;
		maxInput.style.background = minInput.style.background;
	}
}

if (!customElements.get('price-range')) {
	customElements.define('price-range', PriceRange);
}
class FacetRemove extends HTMLElement {
	constructor() {
		super();
		const facetLink = this.querySelector('a');
		facetLink.setAttribute('role', 'button');
		facetLink.addEventListener('click', this.closeFilter.bind(this));
		facetLink.addEventListener('keyup', (event) => {
			event.preventDefault();
			if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
		});
	}

	closeFilter(event) {
		event.preventDefault();
		const form =
			this.closest('facet-filters-form') ||
			document.querySelector('facet-filters-form');
		form.onActiveFilterClick(event);
	}
}

customElements.define('facet-remove', FacetRemove);
